import { YhPageHeader } from "@/erp_subpackage/components/YhPageHeader";
import useGlobalModel from "@/erp_subpackage/model/globalModel";
import React from "react";
import { useTranslation } from 'react-i18next';
import { useRecordModel } from "../recordModel";


export function PageHeader() {
    const { t } = useTranslation();
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useRecordModel();
    const { orgDs } = useGlobalModel(({ orgDs }) => [orgDs]);
    const searchFields = [
        {
            type: "Select",
            placeholder: t(`paper.view.PageHeader.所属机构`),
            fieldName: "org",
            options: orgDs
        },
        {
            type: "Input",
            placeholder: t(`paper.view.PageHeader.创业班组`),
            fieldName: "team"
        },
        {
            type: "RangePicker",
            fieldName: "",
            placeholder: [t(`paper.view.PageHeader.起始事件`), t(`paper.view.PageHeader.结束时间`)],
            rangePickerFieldName: ["startTime", "endTime"],
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        },
    ]


    return (
        <YhPageHeader
            title= {t(`paper.view.PageHeader.答题记录`)}
            size="small"
            triggerSearch
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={(params) => { loadData({ pageNum: 1 }, { ...searchParam, ...params }) }}
            handleReset={resetSearchParam}
        />
    );
}